// src/pages/admin/email/EmailSummary.js
import React, { useEffect, useState } from 'react';
import axios from '../../../utils/axiosWithAuth';
import { Link } from 'react-router-dom';

const EmailSummary = () => {
  const [summary, setSummary] = useState({
    totalSubscribers: 0,
    emailsToday: 0,
    unsubscribed: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const [subs, stats] = await Promise.all([
         axios.get(`${process.env.REACT_APP_API_URL}/api/subscribers`),
axios.get(`${process.env.REACT_APP_API_URL}/api/email/stats`),

        ]);
        setSummary({
          totalSubscribers: subs.data?.length || 0,
          emailsToday: stats.data?.emailsToday || 0,
          unsubscribed: stats.data?.unsubscribed || 0,
        });
      } catch (err) {
        console.error('❌ Failed to load email summary:', err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, []);

  const cards = [
    {
      label: 'Subscribers',
      icon: '📧',
      value: summary.totalSubscribers,
      bg: 'bg-primary',
    },
    {
      label: 'Emails Today',
      icon: '📤',
      value: summary.emailsToday,
      bg: 'bg-success',
    },
    {
      label: 'Unsubscribed',
      icon: '🚫',
      value: summary.unsubscribed,
      bg: 'bg-danger',
    },
  ];

  if (loading) return <div className="text-center py-5">⏳ Loading summary...</div>;

  return (
    <div className="email-summary container py-3">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0">📊 Email Summary</h4>
        
      </div>

      <div className="row">
        {cards.map((card) => (
          <div className="col-md-4 mb-3" key={card.label}>
            <div className={`card shadow-sm text-white ${card.bg}`}>
              <div className="card-body text-center">
                <h5>{card.icon} {card.label}</h5>
                <p className="h3">{card.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmailSummary;
